import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo, { breadcrumbSchema } from "@/components/Seo";
import PageHero from "@/components/shared/PageHero";
import CtaSection from "@/components/shared/CtaSection";
import DynamicIcon from "@/components/shared/DynamicIcon";
import { Stagger, StaggerItem } from "@/components/motion/Reveal";
import { INDUSTRIES } from "@/data/industries";

export default function IndustriesHub() {
  return (
    <>
      <Seo
        title="GEO by Industry — AI Search Optimization for Your Sector"
        description="Industry-specific Generative Engine Optimization from CompuBrain AI: manufacturing, real estate, healthcare, SaaS, education, finance, hospitality, automotive and enterprise GEO."
        path="/industries"
        schemas={[breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Industries", path: "/industries" }])]}
      />
      <PageHero
        eyebrow="Industries"
        titleLines={["GEO tailored to", "your industry."]}
        sub="AI describes and recommends brands differently in every sector. We bring domain expertise across 16+ industries to make your business the answer."
        breadcrumbs={[{ name: "Home", path: "/" }, { name: "Industries" }]}
      />
      <section className="max-w-7xl mx-auto px-6 lg:px-12 py-20 lg:py-28">
        <Stagger className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {INDUSTRIES.map((ind) => (
            <StaggerItem key={ind.slug}>
              <Link
                to={`/industries/${ind.slug}`}
                data-testid={`industry-hub-card-${ind.slug}`}
                className="group flex flex-col h-full rounded-2xl border border-gray-200 p-8 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(0,0,0,0.06)] hover:border-gray-300 transition-all duration-500"
              >
                <div className="h-12 w-12 rounded-xl bg-[#6E56CF]/[0.1] flex items-center justify-center text-[#6E56CF] group-hover:bg-[#6E56CF] group-hover:text-white transition-colors">
                  <DynamicIcon name={ind.icon} className="h-6 w-6" />
                </div>
                <h2 className="font-display text-xl font-bold tracking-tight mt-6">{ind.title}</h2>
                <p className="text-[15px] text-gray-600 mt-3 leading-relaxed flex-1">{ind.short}</p>
                <span className="mt-6 inline-flex items-center gap-1 text-sm font-medium text-[#0B63F6]">
                  Explore <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </Link>
            </StaggerItem>
          ))}
        </Stagger>
      </section>
      <CtaSection heading="Don't see your industry?" sub="We work across 16+ sectors. Tell us about your business and we'll tailor a GEO strategy for you." />
    </>
  );
}
